import type { DatePickerDesignTokens, DatePickerTokenSections } from '@openng/optimus-ui-themes/types/datepicker';

export const date: DatePickerTokenSections.Date = {
	borderRadius: '{datepicker.date.width} / 2',
};

export default {
	date,
} satisfies DatePickerDesignTokens;
